import React from 'react';

import { staticPages as staticPagesApi } from 'client/redux/api/static-pages';
import { TARGET_VALUES } from 'models/other/interface';

import css from './FooterDisclaimer.module.scss';

const FooterDisclaimer = () => {
  const { data } = staticPagesApi.endpoints.getStaticPage.useQuery({
    target: TARGET_VALUES.FOOTER_DISCLAIMER,
  });

  const disclaimerData = data?.success ? data.data : undefined;

  if (!disclaimerData) return null;

  return (
    <div className={css.footerDisclaimer}>
      <h3 className={css.title}>{disclaimerData.title}</h3>
      <div className={css.text} dangerouslySetInnerHTML={{ __html: disclaimerData.body }}></div>
    </div>
  );
};

export default FooterDisclaimer;
